import axios from 'axios';

const baseURL = `api/measures`;

export default {
    getMeasuresCharacteristics(nprogress: any) {
        const token = localStorage.getItem('token')
        axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return axios.get(baseURL, nprogress);
    },

    fetchDoorLeafSizes() {
        const token = localStorage.getItem('token')
        axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return axios.get(process.env.VUE_APP_SERVICE_URL + 'api/doorleafsizes');
    }
};